import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {SELECTED_OTHER_ROWS, SELECTED_ROW} from 'search/blast/BLASTAlignmentUtil';
import {Triangle} from 'search/blast/GraphDragZoomScreen';
import {NEAR_BLACK} from 'ui-library/Colors';

interface PairwiseDragZoomScreenProps {
  totalLength: number;
  graySelected?: boolean;
  orangeSelected?: boolean;
  leftEdge?: boolean;
  rightEdge?: boolean;
  isQuery?: boolean;
}

export default function PairwiseDragZoomScreen(props: PairwiseDragZoomScreenProps): JSX.Element {
  if (props.isQuery) {
    return (
      <>
        {props.leftEdge && <LeftSVGAndTriangle x={1} y={1} totalLength={props.totalLength} />}
        {props.leftEdge && <div className={css(styles.leftEdge, styles.queryEdge)} />}
        {props.rightEdge && <RightSVGAndTriangle x={1} y={1} totalLength={props.totalLength} />}
        {props.rightEdge && <div className={css(styles.rightEdge, styles.queryEdge)} />}
      </>
    );
  } else {
    return (
      <>
        {props.leftEdge && <div className={css(styles.leftEdge)} />}
        {props.graySelected && <div className={css(styles.graySelected)} />}
        {props.orangeSelected && <div className={css(styles.orangeSelected)} />}
        {props.rightEdge && <div className={css(styles.rightEdge)} />}
      </>
    );
  }
}

function LeftSVGAndTriangle({x, y, totalLength}: {x: number; y: number; totalLength: number}): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={totalLength}
      height={1000}
      fill="none"
      className={css(styles.leftSvg)}
    >
      <Triangle x={6} y={0} />
    </svg>
  );
}

function RightSVGAndTriangle({x, y, totalLength}: {x: number; y: number; totalLength: number}): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={1000}
      fill="none"
      className={css(styles.rightSvg)}
    >
      <Triangle x={6} y={0} />
    </svg>
  );
}

const styles = StyleSheet.create({
  queryEdge: {
    bottom: '-50px',
  },
  leftEdge: {
    position: 'absolute',
    width: '2px',
    top: '-1px',
    bottom: '-1px',
    left: '0px',
    zIndex: 1,
    backgroundColor: NEAR_BLACK,
  },
  leftSvg: {
    left: '-5px',
    top: 0,
    position: 'absolute',
    zIndex: 99,
    shapeRendering: 'crispEdges',
  },
  rightEdge: {
    position: 'absolute',
    width: '2px',
    top: '-1px',
    bottom: '-1px',
    right: '-2px',
    zIndex: 1,
    backgroundColor: NEAR_BLACK,
  },
  rightSvg: {
    right: '-7px',
    top: 0,
    position: 'absolute',
    zIndex: 99,
    shapeRendering: 'crispEdges',
  },
  graySelected: {
    backgroundColor: SELECTED_OTHER_ROWS,
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '100%',
    zIndex: -1,
  },
  orangeSelected: {
    backgroundColor: SELECTED_ROW,
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '100%',
    zIndex: -1,
  },
});
